<template>



    <section id="prepack" v-if="ready">


        <b-container fluid>
            <b-row class="header">

                <b-card overlay :img-src="require(`../../assets/images/prepack/ppbg.jpg`)"
                    img-alt="Prepack Planner Background" text-variant="white">

                                <div class="aspect-ratio"></div>

                    <b-card-text class="headline" >
                        <h1 v-bind:class="{ 'blur': blurheadline}">A fast way to find your <br><span>Flavour</span></h1>
                    </b-card-text>


                    <b-row class="main-row" align-h="end">
                        <b-col col order="2" order-md="1" cols="12" md="6" lg="4" xl="3" class="main-info">
                            <b-card-text class="info-container">
                                <h2>Thousands of displays, <br>ready to order.</h2>
                                <p>With so many McCormick brands gracing the floors of our favourite grocery store
                                    chains across the country, the number of actual displays really start to add up.
                                    McCormick tasked our team with developing an online tool for McCormick sales and
                                    customers alike to plan out their display strategy. </p>
                            </b-card-text>
                        </b-col>

                                  
                        <b-col col order="1" order-md="2" cols="12" md="5" lg="7" xl="8" class="main-display">
                                <parallax breakpoint="(min-width: 992px)"><b-img fluid :src="require(`../../assets/images/prepack/newppipad.png`)"></b-img></parallax> 
                        </b-col>
                               

                    </b-row>

                </b-card>

            </b-row>
        </b-container>


        <b-container fluid class="content-container">

            <b-row class="sugarspice">
                <b-col data-aos="fade-right" col cols="12" md="6" class="mac-display">
                    <b-img  class="imac" :src="require(`../../assets/images/prepack/laptop-phone.png`)" fluid
                        alt="McCormick's Prepack Planner UI Design by Branton"></b-img>
                </b-col>
                <b-col data-aos="fade-left" col cols="12" md="6" class="content-subcontainer">
                    <div class="content">
                        <h2><span class="sml">Sugar and spice and</span> <br><span class="mid"> everything</span> <br class="break"><span
                                class="large"> nice</span><span class="period">.</span></h2>
                        <p>The issue McCormick was having with their displays was how they were being organized
                            digitally with separate spec sheets in a database on a platform that could only be used on a
                            desktop computer with a cluttered interface. With the sales force equipped with specific
                            tablets in the field, the application needed to not only function in an intuitive fashion on
                            that specific platform, but seamlessly adapt to any device.</p>
                    </div>
                </b-col>
            </b-row>



            <b-row class="details">

                    <b-col data-aos="fade-right" col cols="12" md="6">
                        <!-- <b-img fluid class="icon" :src="require(`../../assets/images/prepack/front-end-icon.svg`)" alt="Front-End Development Icon"></b-img> -->
                        <h2>Front-end design</h2>
                        <ul>
                            <li>
                                <h3>1. Refreshed Design</h3>
                                <p>The Prepack Planner design took the old dry spreadsheet-style tool to a more brand-aligned, fresh, appealing look and feel. The refined interface design made the flavour jump off the page while maintaining a high level of functionality to quickly and easily find the display you want. No more prepack in a hay stack!</p>
                            </li>
                            <li>
                                <h3>2. UI Enhancement</h3>
                                <p>A sleek user interface to navigate the expansive catalogue of prepacks required several methods to search for them. Through planning and mapping out all the most practical pathways we made it easy for the user to find what they are looking for, no matter how little information they had to use in their search.</p>
                            </li>
                        </ul>
                    </b-col>

                    

                    <b-col data-aos="fade-left" col cols="12" md="6">
                       <!-- <b-img fluid class="icon" :src="require(`../../assets/images/prepack/back-end-icon.svg`)" alt="Back-End Development Icon"></b-img> -->
                        <h2>Back-end development</h2>
                         <ul>
                            <li>
                                <h3>1. Content Control Panel</h3>
                                <p>Anyone with administrative access can simply log in and manage most aspects of The Prepack Planner including feature product banners, prepacks and associated data, products, and user accounts.</p>
                            </li>
                            <li>
                                <h3>2. User Management</h3>
                                <p>User account holders are able to manage their personal data with ease.  Admin accounts have the ability to add, remove or edit a user. New users may also join via invite codes.</p>
                            </li>
                            <li>
                                <h3>3. Advanced Search</h3>
                                <p>In addition to the multiple search methods, an advanced search system was developed enabling the user to type any information into the search box which would then produce results related to that information. The advanced search system uses keyword tagging so users can use more obvious search terms such as Backyard Spices, or Limited Edition Sauces. </p>
                            </li>
                        </ul>

                    </b-col>

                </b-row>


            <b-row class="bottom-content display-flexibility">
                    <b-col data-aos="fade-right" col cols="12" md="5" lg="6" class="ipad-display">
                     <b-img class="ipad" :src="require(`../../assets/images/prepack/ipad-prepack.png`)" fluid
                        alt="McCormick's Prepack Planner UI Design by Branton"></b-img>
                    </b-col>
                    <b-col data-aos="fade-left" col cols="12" md="7" lg="6" class="content-wrapper ipad-content-wrapper">
                        <div class="content ipad-content">
                        <h3>Display flexibility.</h3>
                        <p>The Prepack Planner was developed with all screen sizes and devices in mind so the user could seamlessly enjoy all features available. Although the majority of the sales force uses tablets, they may also run their searches conveniently on their smartphone for additional speed and convenience.</p>
                        </div>
                    </b-col>
                </b-row>


                                  <b-row class="bottom-content sales-tool">

                   <b-col data-aos="fade-right" order="2" order-md="1" col cols="12" md="7" class="content-wrapper macbook-content-wrapper">
                        <div class="content macbook-content">
                        <h3>An invaluable sales tool.</h3>
                        <p>When a little extra preparation is needed, reps have access to the Prepack Planner tool on any home or work computer at any time. The Prepack Planner can export product-specific sales sheets in PDF and MS Excel formats as leave-behinds post-presentation.</p>
                        </div>
                    </b-col>

                    <b-col data-aos="fade-left" order="1" order-md="2" col cols="12" md="5"  class="laptop-display">
                                             <b-img class="macbook" :src="require(`../../assets/images/prepack/prepack-laptop.png`)" fluid
                        alt="McCormick's Prepack Planner UI Design by Branton"></b-img>
                    </b-col>
           
                </b-row>




        </b-container>


            <!-- <b-container fluid class="otherprojects universe" :class="{ 'section-animation-in': hover }">

                       
        <div class="slide project-preview-container section-animation-in" :class="{ 'section-animation-in': hover }" id="slide1" data-project="1">

          <div class="preview-text-container">
            <div class="preview-container">
              <h2>
                <div class="text-row"><span class="otherprojecthead">Control Your Universe.</span></div>
                <div class="text-row"><span class="changeme">Any time, anywhere. Heating and cooling systems for
                    high-rise condos.</span></div>
              </h2>

              <router-link to="/work/universe" class="animated-home-button">
                <div class="button-container">
                  <div class="button-content">
                    <div class="arrow-container">
                      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492"
                        style="enable-background:new 0 0 492 492;" xml:space="preserve">
                        <g>
                          <g>
                            <path
                              d="M293.4,245.9L109.3,430c-5.1,5.1-7.9,11.8-7.9,19c0,7.2,2.8,14,7.9,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9L382.7,265c5.1-5.1,7.9-11.9,7.8-19.1c0-7.2-2.8-14-7.8-19.1L163.7,7.9c-5.1-5.1-11.8-7.9-19-7.9c-7.2,0-14,2.8-19,7.9L109.5,24C99,34.5,99,51.6,109.5,62L293.4,245.9z" />
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        </b-container> -->

        <div class="container-fluid otherwork" :class="{ 'section-animation-in': hover }">

<h4>See work <span>that matters.</span></h4>

<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[0] }">
<div class="image-container">
    <div class="divide"></div>
    <router-link to="/work/universe" class="content">
      <span class="projecttype dark">APP DEVELOPMENT</span>
      <span class="otherprojecthead dark">Unilux VFC</span>
      <span class="changeme dark">Control your universe.</span>
</router-link>

  <img class="fade-in-image" :src="require(`../../assets/images/universe-other.png`)" alt="Your image">
</div>
</div>

<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[1] }">
<div class="image-container">
    <div class="divide"></div>
    <router-link to="/work/winning" class="content">
      <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
      <span class="otherprojecthead">3M Electrical</span>
      <span class="changeme">Uncover the secret.</span>
</router-link>

  <img class="fade-in-image" :src="require(`../../assets/images/winning-other.png`)" alt="Your image">
</div>
</div>


<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[2] }">
<div class="image-container">
    <div class="divide"></div>
    <router-link to="/work/clarity" class="content">
      <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
     <span class="otherprojecthead">3M Clarity</span>
     <span class="changeme">Smiles for miles.</span>
</router-link>

  <img class="fade-in-image" :src="require(`../../assets/images/clarity-other.png`)" alt="Your image">
</div>
</div>

<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[3] }">
  <div class="image-container">
      <div class="divide"></div>
      <router-link to="/work/surface" class="content">     
        <span class="projecttype dark">CAMPAIGN DEVELOPMENT</span>
         <span class="otherprojecthead dark">3M Food Safety</span>
         <span class="changem dark">See beyond the surface.</span>
    </router-link>
  
    <img class="fade-in-image" :src="require(`../../assets/images/surface-other.png`)" alt="Your image">
  </div>
  </div>



<div class="preview-text-container" @click="toggleActive" :class="{'additional-class': activeStates[4] }">
<div class="image-container">
    <div class="divide"></div>
    <router-link to="/work/higher" class="content">  
      <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
      <span class="otherprojecthead">3M Fall Protection</span>
     <span class="changeme">Bottom lines to new heights.</span>

</router-link>
  <img class="fade-in-image" :src="require(`../../assets/images/higher-other.png`)" alt="Your image">
</div>
</div>


</div>



    </section>
</template>

<script>
    import Parallax from 'vue-parallaxy'

    //AOS Animations
    import AOS from 'aos';
    import 'aos/dist/aos.css';

    export default {
        components: {
            Parallax
        },
        data() {
            return {
                hover: false,
                ready: false,
                blurheadline: false,
                isActive: false,
                activeStates: {},
            };
        },
        metaInfo: {
            titleTemplate: 'A Fast Way to Find your Flavour | Branton  — a Creation Company.',
            meta: [{
                name: "Our Work",
                content: "McCormick’s Prepack Planner, a sales-enablement tool created by Branton. Build, plan, and order in-store displays with just a few taps of a finger. "
            }]
        },
        methods: {
            initializeObservers() {
  const elements = this.$el.querySelectorAll('.preview-text-container');
  if (elements.length === 0) {
    console.error('No elements found');
    return;
  }
  elements.forEach((element, index) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        console.log(`Element ${index} is intersecting: ${entry.isIntersecting}`);
        this.$set(this.activeStates, index, entry.isIntersecting);
      });
    }, { threshold: 1 });

    observer.observe(element);
  });
},
     
                        handleScroll() {
                if (window.scrollY > 200) {
                    this.blurheadline = true;
                } else {
                    this.blurheadline = false;
                }
                        },
                        toggleActive(event) {
      event.currentTarget.classList.toggle('active');
    },
        },
        mounted() {

            this.$nextTick(() => {
    this.initializeObservers();
  });


                this.ready = true;

   this.$gtag.pageview({
        page_path: '/work/prepack-planner',
      })

                if(this.ready){
                    AOS.init();
                    AOS.refresh();
                    setTimeout(function () { 
                        AOS.refresh();
                        }.bind(this), 300)
                }
        },
               created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        }
        
    }
</script>

<style lang="scss">
    @import '@/assets/css/prepack.scss';
</style>